// billboars modules
import axios from '@/api/http_client';
import { BILLBOARD_URL } from '../../api/url.js';

// initial state
// shape: [{ images }]
const state = {
  billboardImages: [],
}


// actions
const actions = {
  fetchBillboardImages(context) {
    const config = {
      method: 'get',
      url: BILLBOARD_URL,
      params: {
        Mobile: true,
      },
    };
    axios(config)
    .then((response) => {
      context.commit('fetchBillboardImages', response.data);
    }, (err) => {
      console.log("billboard error:", err);
    })
  },
};

// mutations
const mutations = {
  fetchBillboardImages(state, payload) {
    state.billboardImages = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/billboard.js